module.exports = __webpack_public_path__ + "static/media/9.89e3e982.jpg";